module.exports = __webpack_public_path__ + "static/media/1.388afeb7.jpg";